var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "edit_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#edit_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15.5h.927l8.197-8.197-.927-.926L4.5 14.574v.926zm-.41 1.083a.658.658 0 01-.477-.191.638.638 0 01-.196-.475v-1.232a1.315 1.315 0 01.397-.965l9.97-9.986c.112-.115.233-.196.362-.245a1.212 1.212 0 01.812-.005c.128.046.253.127.374.242l.934.926c.116.12.197.246.246.375a1.163 1.163 0 01-.004.817c-.05.133-.131.254-.242.364l-9.985 9.978a1.316 1.316 0 01-.963.397H4.091zm9.063-9.735l-.456-.471.927.926-.472-.455z",
    fill: "#7A8D8F"
  }))));
}
export default SvgEdit;